import * as _ from 'lodash';
import { type ColumnHandler } from '../types';
import { parseJson } from '../converters';
import { type ProgressTrackingColumnType } from '../../monday-api/api';

export type ProgressColumnValue = {
  text: string | null;
  percentage_done: number | null;
};

export type ProgressColumnSettings = {
  related_columns: {
    isNormalized: boolean;
    columns: Record<
      string,
      {
        isSelected: boolean;
        percentage: number;
      }
    >;
  };
};

const handler: ColumnHandler<ProgressTrackingColumnType, ProgressColumnValue, ProgressColumnSettings> = {
  type: 'progress',

  default_value_field: 'text',

  supported_rules: [],

  convertValueFromMondayToEngine: (columnValue, boardItem, board) => {
    let percentageDone: number | null = null;

    if (boardItem && board) {
      try {
        const boardColumn = board.columns.find((column) => column.id === columnValue.id);

        let settings;

        if (boardColumn?.settings_str) {
          settings = parseJson(boardColumn?.settings_str) as ProgressColumnSettings;
        }

        const referencedStatusColumns = Object.entries(settings?.related_columns?.columns || {})
          .filter(([_columnId, columnSettings]) => columnSettings?.isSelected)
          .flatMap(([columnId, columnSettings]) => {
            const statusColumn = board.columns.find((column) => column.id === columnId);

            if (!statusColumn) {
              return [
                {
                  columnId,
                  weight: columnSettings.percentage,
                  isDone: false,
                },
              ];
            }

            const statusColumnSettings = statusColumn.settings_str ? parseJson(statusColumn.settings_str) : null;
            const doneStatusIdx = statusColumnSettings?.done_colors || [];
            const statusColumnValue = boardItem.column_values.find((value) => value.id === columnId);
            let isDone = false;

            if (statusColumnValue && statusColumnValue?.value) {
              const statusValue = parseJson(statusColumnValue.value);

              if (statusValue?.index !== undefined && doneStatusIdx.includes(statusValue.index)) {
                isDone = true;
              }
            }

            return { columnId, weight: columnSettings.percentage, isDone };
          });

        percentageDone = referencedStatusColumns.reduce((acc, { weight, isDone }) => {
          if (isDone) {
            return acc + weight;
          }
          return acc;
        }, 0);
      } catch (err) {}
    }

    return {
      text: percentageDone !== null ? `${percentageDone}%` : '',
      percentage_done: percentageDone,
    };
  },

  convertSettingsToEngine: (settings: string) => {
    return parseJson(settings) as ProgressColumnSettings;
  },
};

export default handler;
